import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonContent, IonList, IonItem, IonInfiniteScroll, IonInfiniteScrollContent, IonHeader, IonFooter } from '@ionic/react';
import ReactDOM from 'react-dom';


import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';
import { ActiveOrderDetailsModal } from './Modal_ActiveOrderDetails';

import { ViewInvoiceModal } from '../../zInternal_Features/merchant/components/Modal_ViewInvoice';

//import classes from './Modal_ViewModal.module.css';
import '../../../css/qavaApp.css';

const Backdrop = props => {
    return <div className='backdrop'/>
};

export function ViewActiveOrderListModal (props) {

    let authClient_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authClient_context.acctID);
    const [schema, setSchemaName ] = useState(authClient_context.schema);
    let [sessionID, setSessionID ] = useState(authClient_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authClient_context.baseURL);

    let [startDate, setStartDate] = useState(props.startDate);
    let [endDate, setEndDate] = useState(props.endDate);

    let [viewOrders, setViewOrders] = useState([]);

    let [orderID, setOrderID] = useState(null);
    let [orderTotal, setOrderTotal] = useState(null);

    let [showOrderDetailsModal, setShowOrderDetailsModal] = useState(false);

    let [invoiceForm, setInvoiceForm] = useState(null);
    let [showInvoiceModal, setViewInvoiceModal] = useState(null);

    useEffect(() => {



        if(props.openModal == true && startDate != null && endDate != null)
        {

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74101_view_active_Orders_data',
                    user: acctID,
                    xStartDateRange: authClient_context.startDate,
                    xEndDateRange: authClient_context.endDate,
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'userAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');


                    setViewOrders((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            orderID: cols[0],
                            cartID: cols[1],
                            orderPhoneNumber: cols[2],
                            clientFirstName: cols[3],
                            clientLastName: cols[4],
                            clientPhoneNumber: cols[5],
                            emailAddress: cols[6],
                            paymentType: cols[7],
                            memberNumber: cols[8],
                            momo_provider: cols[9],
                            momo_number: cols[10],
                            orderTotal: cols[11],
                            orderAmtPaid: cols[12],
                            orderStartDate_reserved: cols[13],
                            orderEndDate_reserved: cols[14],
                            orderStartDate: cols[15],
                            orderEndDate: cols[16],
                            merchantInvoiceID: cols[17],
                            invoiceForm: cols[18],
                            customerInvoiceID: cols[19],
                            invoiceTotal: parseFloat(cols[20]).toFixed(2),
                            transactionID: cols[21],
                            totalInvoiceAmount: cols[22],
                            transactionStatus: cols[23],
                            momo_provider: cols[24],
                            momo_financial_transaction_id: cols[25],
                            momo_external_id: cols[26],
                            momo_amount: cols[27],
                            momo_party_id: cols[28],
                            momo_payer_message: cols[29],
                            momo_payee_note: cols[30],
                            momo_pay_status: cols[31],
                            payment_type: cols[32],
                            verifyIDType: cols[33],
                            verifyIDNumber: cols[34],
                            shipToAddress: cols[35],
                            latitude: cols[36],
                            longitude: cols[37],
                            status: cols[38],
                        })
                    });
                } 
            })
        }
    }, [props.openModal]);

    function deleteEstimate(enteredPassword)
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', '74002D');
        formData.append('user', acctID);
        formData.append('xorderID', orderID);
        formData.append('xEnterAdminPassword', enteredPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74002D',
                user: acctID,
                xorderID: orderID,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'userAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function closeModalHandler(event) {

        setViewOrders([]);
        props.closeModal(event);
    }
 
    function viewOrderDetailsHandler(event) {


        setOrderID(event[0]);
        setShowOrderDetailsModal(true);

        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }

    function viewDeleteEstimateHandler(event) {


        //setShowPasswordModal(event[0]);
        setOrderID(event);
    }

    function onSubmitPasswordHandler(event)
    {
        deleteEstimate(event);
    }

    function viewInvoiceModalHandler(event) {

        //alert(event);

        setOrderID(event[1]);
        setOrderTotal(event[2]);
        setInvoiceForm(event[3]);
        setViewInvoiceModal(event[0]);

    }



    return (

        <React.Fragment> 
           
            {props.openModal == true ?
            (
                <div>
                {ReactDOM.createPortal(<Backdrop />, document.getElementById('backdrop-root'))}

                <IonModal isOpen={ props.openModal }>
                    <IonHeader style={{ color: "black" }}>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='12'>
                                    <h3> ACTIVE ORDERS </h3>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>

                    <IonContent >
                        <IonGrid className='appGridContent'>
                            <IonRow >
                                    <IonCol size='2'> <h3> ID </h3> </IonCol>
                                    <IonCol size='2'> <h3> Total </h3> </IonCol>
                                    {/*<IonCol className='appGridCol' size='3'> <h3> Estimate Description </h3> </IonCol>*/}
                                    <IonCol size='5'> <h3> status </h3> </IonCol>
                                    <IonCol size='3'> <h3> Action </h3> </IonCol>
                            </IonRow>
                        {viewOrders.map((detailData) =>   {
                            return (
                                    <IonRow key={detailData.orderID}>
                                        <IonCol size='2'>{detailData.orderID}</IonCol>
                                        <IonCol size='2'>{detailData.invoiceTotal}</IonCol>
                                        {/*<IonCol className='appGridCol' size='3'>{detailData.expenseDescription}</IonCol>*/}
                                        <IonCol size='5'>{detailData.status}</IonCol>
                                        <IonCol size='3'>
                                            {/*<IonButton class='gridResultColumnButton' onClick={() => viewInvoiceModalHandler([true, detailData.orderID, detailData.invoiceTotal, detailData.invoiceForm])}> View </IonButton>*/}
                                            <IonButton onClick={() => viewOrderDetailsHandler([detailData.orderID])}> Details </IonButton>                                    
                                        </IonCol>
                                    </IonRow>
                            )
                        }
                        )}
                        </IonGrid>


                    {showInvoiceModal == true && <ViewInvoiceModal openModal={ showInvoiceModal } closeModal={() => setViewInvoiceModal(false)} data={{
                                        fileLocation: `/api/form/${invoiceForm}/${schema}`, 
                                        }}></ViewInvoiceModal>}

                    {showOrderDetailsModal == true && <ActiveOrderDetailsModal openModal={ showOrderDetailsModal } closeModal={() => setShowOrderDetailsModal(false)} data={{
                                        orderID: orderID, 
                                        }}></ActiveOrderDetailsModal>}

                    </IonContent>

                    <IonFooter className='modal_footer_button_center'>
                        <IonButton onClick={() => closeModalHandler(false)}> Close </IonButton>
                    </IonFooter>

                </IonModal>            
            </div>
            ) : null }

        </React.Fragment>

    )
}